export default {"src":"/_next/static/media/arrow-big.e723219e.svg","height":16,"width":18};